/**
 * Centralized field type configuration for conditional logic
 * This prevents discrepancies between different components that handle field types
 */

type FieldType = string;

interface FieldTypeConfig {
	readonly numericTypes: readonly FieldType[];
	readonly checkboxTypes: readonly FieldType[];
}

const fieldTypeConfig: FieldTypeConfig = {
	// Field types that support numeric comparison operators (is greater than, is less than)
	numericTypes: ['numeric', 'currency', 'formula'] as const,

	// Field types that support checkbox operators (is checked, is not checked)
	checkboxTypes: ['checkbox'] as const,
};

/**
 * Check if a field type supports numeric comparison operators
 */
const supportsNumericOperators = (fieldType: FieldType): boolean => fieldTypeConfig.numericTypes.includes(fieldType);

/**
 * Check if a field type supports checkbox operators
 */
const supportsCheckboxOperators = (fieldType: FieldType): boolean => fieldTypeConfig.checkboxTypes.includes(fieldType);

export { fieldTypeConfig, supportsNumericOperators, supportsCheckboxOperators };
